<template>
  <ol class="timeline">
    <li v-for="entry in entries" :key="entry.title + entry.period">
      <article>
        <p class="period">{{ entry.period }}</p>
        <div class="body">
          <h3>{{ entry.title }}</h3>
          <p v-if="entry.role" class="role">{{ entry.role }}</p>
          <p v-if="entry.text" class="text">{{ entry.text }}</p>
          <ul v-if="entry.items">
            <li v-for="item in entry.items" :key="item">{{ item }}</li>
          </ul>
          <template v-if="entry.groups">
            <div v-for="group in entry.groups" :key="group.label" class="group">
              <h4>{{ group.label }}</h4>
              <ul>
                <li v-for="item in group.items" :key="item">{{ item }}</li>
              </ul>
            </div>
          </template>
        </div>
        <img v-if="entry.logo" class="logo" :class="{'logo--dark': entry.logoOnDark}" :src="entry.logo" alt="" width="96" height="64" loading="lazy">
      </article>
    </li>
  </ol>
</template>

<script>
  /**
   * Liste chronologique (expériences, formations). Chaque entrée : {title, period, role, text, items[], groups[{label, items[]}], logo, logoOnDark}.
   * Les logos sont décoratifs : le nom de la structure est déjà dans le titre.
   * logoOnDark : logo aux lettres claires, posé sur une pastille bleu nuit pour rester lisible sur le papier.
   */
  export default {
    name: 'TimelineList',
    props: {
      entries: {type: Array, required: true},
    },
  }
</script>

<style lang="stylus" scoped>
@import '~/src/common/style/constants.styl';

.timeline
  list-style none
  margin 0
  padding 0
  border-top 2px solid INK
  > li
    margin 0
    padding 0
    border-bottom 1px solid RULE

article
  display grid
  gap 8px 32px
  padding 28px 0

.period
  margin 0
  color MUTED
  font-size 0.95rem
  font-weight 600

h3
  margin 0
  font-size 1.35rem

.role
  margin 4px 0 0
  color INK
  font-weight 650

.text
  margin 10px 0 0
  color INK_SOFT
  max-width 70ch

ul
  margin 10px 0 0
  padding-left 1.2em
  li
    margin-top 4px
    color INK_SOFT
    &::marker
      color LEMON_DEEP

.group
  margin-top 14px
  h4
    margin 0
    font-family inherit
    font-size 1rem
    font-weight 700

.logo
  justify-self start
  box-sizing border-box
  width auto
  height auto
  max-width 96px
  max-height 64px
  object-fit contain

.logo--dark
  padding 8px 10px
  border-radius 6px
  background INK

@media (min-width: DESKTOP_SIZE)
  article
    grid-template-columns 190px 1fr 120px
    align-items start
  .logo
    justify-self end
</style>
